export default {
  set (name, value, days) {
    var exp = new Date()
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
    // 跨域登录
    // document.cookie = name + '=' + escape(value) + ';path=/;domain=' + document.domain
    //    .split('.')
    //    .slice(-2)
    //     .join('.') + ';expires=' + exp.toGMTString()
    // 非跨域登录
    document.cookie = name + '=' + escape(value) + ';path=/;domain=' + document.domain + ';expires=' + exp.toGMTString()
  },
  get (name) {
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr !== null) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  del (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.get(name)
    if (cval !== null) {
      // 跨域
      // document.cookie = name + '=' + cval + ';path=/;;domain=' + document.domain
      //   .split('.')
      //   .slice(-2)
      //   .join('.') + ';expires=' + exp.toGMTString()
      // 非跨域
      document.cookie = name + '=' + cval + ';path=/;;domain=' + document.domain + ';expires=' + exp.toGMTString()
    }
  },
  // userId: function () {
  //   if (this.get('ssotoken')) {
  //     return this.get('ssotoken').split('.')[0]
  //   }
  // },
  token: function () {
    if (this.get('ssotoken')) {
      return this.get('ssotoken')
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/cookie.js